import React, { useEffect, useState } from "react";
import { api } from "../api";
import { Box, Typography, Tabs, Tab, Table, TableHead, TableRow, TableCell, TableBody, Chip } from "@mui/material";

function ContactInbox() {
  const [rows, setRows] = useState([]);
  const load = () =>
    api.get("/sk12_contactsubmissions").then((r) =>
      setRows((r.data || []).sort((a, b) => (b.CreatedOn || "").localeCompare(a.CreatedOn || ""))));
  useEffect(() => { load(); }, []);
  const cycle = async (row) => {
    const Status = row.Status === "New" ? "Read" : row.Status === "Read" ? "Archived" : "New";
    await api.put(`/sk12_contactsubmissions/${row.apiid}`, {
      Name: row.Name, Email: row.Email, Phone: row.Phone, Interests: row.Interests, Message: row.Message, Status,
    });
    load();
  };
  return (
    <Table size="small">
      <TableHead><TableRow>
        <TableCell>When</TableCell><TableCell>Name</TableCell><TableCell>Email</TableCell><TableCell>Message</TableCell><TableCell>Status</TableCell>
      </TableRow></TableHead>
      <TableBody>
        {rows.map((r) => (
          <TableRow key={r.apiid}>
            <TableCell>{(r.CreatedOn || "").slice(0, 16).replace("T", " ")}</TableCell>
            <TableCell>{r.Name}</TableCell>
            <TableCell>{r.Email}</TableCell>
            <TableCell sx={{ maxWidth: 320 }}>{r.Message}</TableCell>
            <TableCell>
              <Chip size="small" label={r.Status || "New"}
                color={r.Status === "Archived" ? "default" : r.Status === "Read" ? "info" : "success"}
                onClick={() => cycle(r)} />
            </TableCell>
          </TableRow>
        ))}
        {rows.length === 0 && <TableRow><TableCell colSpan={5}>No contact submissions yet.</TableCell></TableRow>}
      </TableBody>
    </Table>
  );
}

function CareersInbox() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/careerpage").then((r) => setRows(r.data || [])); }, []);
  return (
    <Table size="small">
      <TableHead><TableRow>
        <TableCell>Name</TableCell><TableCell>Email</TableCell><TableCell>Phone</TableCell><TableCell>Position</TableCell>
      </TableRow></TableHead>
      <TableBody>
        {rows.map((r) => (
          <TableRow key={r.apiid}>
            <TableCell>{r.FirstName} {r.LastName}</TableCell>
            <TableCell>{r.Email}</TableCell>
            <TableCell>{r.Phone}</TableCell>
            <TableCell>{r.Position}</TableCell>
          </TableRow>
        ))}
        {rows.length === 0 && <TableRow><TableCell colSpan={4}>No applications yet.</TableCell></TableRow>}
      </TableBody>
    </Table>
  );
}

export default function Submissions() {
  const [tab, setTab] = useState(0);
  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>Submissions</Typography>
      <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ mb: 2 }}>
        <Tab label="Contact" /><Tab label="Careers" />
      </Tabs>
      {tab === 0 ? <ContactInbox /> : <CareersInbox />}
    </Box>
  );
}
